import { IsNotEmpty, IsUUID, IsOptional, MaxLength } from 'class-validator';

const MAX_NAME_LENGTH = 256;

export class CreateCategoryDto {
  @IsUUID()
  @IsNotEmpty({
    message: 'Обязательное поле',
  })
  account_id: string;

  @MaxLength(MAX_NAME_LENGTH, {
    message: `Не более ${MAX_NAME_LENGTH} символов`,
  })
  @IsNotEmpty({
    message: 'Обязательное поле',
  })
  name: string;

  @IsUUID()
  @IsOptional()
  parent_id?: string;
}
